<div class="notification-toast" [ngClass]="severity()" (click)="click()">
    @if (icon()) {
    <span class="icon" *ngIf="icon">{{ icon() }}</span>
    }
	<div class="content">
		<div class="summary">{{ summary() | translate: data() }}</div>
        @if(detail()) {
        <div class="detail">{{ detail() | translate: data() }}</div>
        }

	</div>
    @if(sticky()) { <button class="close" (click)="close($event)">&times;</button>}
</div>